import React, { useEffect } from "react";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { DASHBOARD } from "../../constants/routes";
import { BRAND_NAME } from "../../constants/brand";

/**
 * Go back to the previous in-app page, or to the dashboard when the page
 * was opened directly (no in-app history).
 */
export const useGoBack = () => {
  const navigate = useNavigate();

  return () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(DASHBOARD);
    }
  };
};

/**
 * Browser tab title: "Orders · GoGoPowerJuice"
 */
export const useDocumentTitle = (title) => {
  useEffect(() => {
    const text = typeof title === "string" ? title.trim() : "";
    document.title = text && text !== "--" ? `${text} · ${BRAND_NAME}` : BRAND_NAME;

    return () => {
      document.title = BRAND_NAME;
    };
  }, [title]);
};

const PageHeader = ({ title, eyebrow, onBack, extra }) => {
  useDocumentTitle(title);

  return (
    <div className="page-header">
      <div className="page-header__main">
        {onBack && (
          <Button
            type="text"
            className="page-header__back"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            aria-label="Back"
          />
        )}
        <div className="page-header__text">
          {eyebrow && <div className="page-header__eyebrow">{eyebrow}</div>}
          <Typography.Title level={3} className="page-header__title">
            {title}
          </Typography.Title>
        </div>
      </div>
      {extra && <div className="page-header__extra">{extra}</div>}
    </div>
  );
};

export default PageHeader;
